import styles from './Error.module.css';

function Error() {
 return <h1 className={styles.errorMessage}>Error 404: Página no encontrada</h1>;
}

export default Error;
   